import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { resolveLobbyReturnUrl } from '@low6-pickem/frontend-shared';

const SESSION_KEY = 'dr_from_lobby';
const LOBBY_URL_KEY = 'dr_lobby_return_url';

/**
 * Back-navigation bar when the user arrived from the Lobby.
 * Always navigates to the lobby home URL (/tenant/{code}/lobby/{slug}), not history.back().
 */
export default function LobbyBackBar() {
  const [searchParams] = useSearchParams();
  const fromLobbyParam = searchParams.get('from') === 'lobby';

  useEffect(() => {
    if (fromLobbyParam) {
      sessionStorage.setItem(SESSION_KEY, '1');
      const url = resolveLobbyReturnUrl(searchParams, LOBBY_URL_KEY);
      sessionStorage.setItem(LOBBY_URL_KEY, url);
    }
  }, [fromLobbyParam, searchParams]);

  const visible = fromLobbyParam || sessionStorage.getItem(SESSION_KEY) === '1';
  if (!visible) return null;

  const handleBack = () => {
    sessionStorage.removeItem(SESSION_KEY);
    const url =
      sessionStorage.getItem(LOBBY_URL_KEY) ?? resolveLobbyReturnUrl(searchParams, LOBBY_URL_KEY);
    sessionStorage.removeItem(LOBBY_URL_KEY);
    window.location.href = url;
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Back to Lobby"
      className="fixed top-3 left-3 z-50 flex items-center justify-center w-8 h-8 rounded-full bg-black/60 backdrop-blur-sm text-white hover:bg-black/80 transition-colors"
    >
      <ChevronLeft className="w-5 h-5 flex-shrink-0" strokeWidth={2.5} />
    </button>
  );
}
